export default {
  app: {
    references: {
      references: 'Reference',
      pageTitle: 'Reference - Elixír Tours',
    },
  },
};
